import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'

import { errorLogger } from '@f-fertighaus/utils/errorLogger'

Swiper.use([Navigation, Pagination])

function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[array[i], array[j]] = [array[j], array[i]]
  }
  return array
}

void (async () => {
  const vendorCarousels = document.querySelectorAll(
    '.js-vendor-premium-placement-wrapper'
  )

  vendorCarousels.forEach(vendorCarousel => {
    const container = vendorCarousel.closest('.premium-placement-container')
    if (!container) return

    const paginationEl = container.querySelector('.cards-pagination-bullets')
    const nextEl = container.querySelector('.cards-navigation-button--next')
    const prevEl = container.querySelector('.cards-navigation-button--prev')

    const vendors = Array.from(
      vendorCarousel.querySelectorAll(
        '.js-vendor-premium-placement-carousel-card'
      )
    )

    _wt({
      category: 'item-collection',
      action: 'display',
      label: 'vendor-carousel',
      values: vendors.map(vendor => ({
        type: 'vendor_nid',
        value: vendor.dataset.vendorNid
      }))
    })

    const swiperWrapper = vendorCarousel.querySelector(
      '.js-vendor-premium-placement-carousel-cards'
    )
    if (!swiperWrapper) return

    const slides = Array.from(
      swiperWrapper.querySelectorAll(
        '.js-vendor-premium-placement-carousel-card'
      )
    )

    shuffleArray(slides)

    slides.forEach((slide, index) => {
      if (index > 3) {
        swiperWrapper.removeChild(slide)
      } else {
        swiperWrapper.appendChild(slide)
      }
    })
    swiperWrapper.classList.remove('f-visibility-hidden')

    const swiperSettings = {
      init: false,
      wrapperClass: 'js-vendor-premium-placement-carousel-cards',
      slideClass: 'js-vendor-premium-placement-carousel-card',
      slidesPerView: 'auto',
      spaceBetween: 32,
      loop: true,
      centeredSlides: true,
      pagination: {
        el: paginationEl,
        bulletClass: 'cards-pagination-bullet',
        bulletActiveClass: 'is-active',
        type: 'bullets',
        dynamicBullets: true,
        renderBullet: (index, className) =>
          `<div class='[ f-bo-round ] cards-pagination-bullet ${className}'></div>`
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl
      }
    }

    let swiperInstance = new Swiper(vendorCarousel, swiperSettings)

    const handleClick = event => {
      const card = event.target.closest(
        '.js-vendor-premium-placement-carousel-card'
      )
      if (card && card.dataset.wtdata) {
        try {
          const wtData = JSON.parse(card.dataset.wtdata)
          _wt({
            category: 'item',
            action: 'click',
            values: [{ type: 'vendor_nid', value: card.dataset.vendorNid }],
            ...(wtData.item || {})
          })
        } catch (error) {
          errorLogger(error)
        }
      }
    }

    // Use IntersectionObserver to initialize Swiper when the carousel is visible.
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            swiperInstance.init()
            vendorCarousel.addEventListener('click', handleClick)
            observer.unobserve(entry.target)
          }
        })
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
      }
    )
    observer.observe(vendorCarousel)
  })
})()
